import { useEffect, useState } from "react";
import style from "./EnhancedSearchSideBar.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

import {
  loadingCombinedSearch,
  saveSearchThunk,
  selectIfSearchMatchesSavedSearch,
  selectSavedSearches,
  selectTopicResults
} from "../../../features/enhancedSearch";
import GuidelineFacet from "./GuidelineFacet.jsx";
import useTopicFunctions from "../../../hooks/useTopicFunctions";
import { useDispatch, useSelector } from "react-redux";
import SavedSearchResults from "./SavedSearchResults";
import SaveSearchButton from "./SavedSearchButton";

const SearchResultsSideBar = ({ search, navigate }) => {
  const searchResults = useSelector(selectTopicResults);
  const savedSearchMatchesCurrentSearch = useSelector(selectIfSearchMatchesSavedSearch);
  const savedSearchResults = useSelector(selectSavedSearches);
  const { displaySearch } = useTopicFunctions();
  const [selectedFacet, setSelectedFacet] = useState();
  const dispatch = useDispatch();
  const loadingStatus = useSelector(loadingCombinedSearch);
  let orderedGuidelines = [];
  if (searchResults?.guidelineFacets) {
    orderedGuidelines = Object.keys(searchResults?.guidelineFacets).sort((firstGuideline, secondGuideline) =>
      searchResults?.guidelineFacets[firstGuideline] < searchResults?.guidelineFacets[secondGuideline] ? 1 : -1);
  }

  const getUrlSearchTerm = () => {
    const searchParams = new URLSearchParams(search);
    if (searchParams.has("appendedinputbuttons")) {
      return searchParams.get("appendedinputbuttons");
    }
  }

  const buildSearchUrl = (searchTerm, guidelineTitle) => {
    let baseUrl = `/searchAction/?appendedinputbuttons=${encodeURIComponent(searchTerm)}`;
    if (guidelineTitle) {
      baseUrl += `&guidelinefilter=${encodeURIComponent(guidelineTitle)}`;
    }
    return baseUrl;
  }


  const clickOnGuidelineFacet = (guidelineTitle) => () => {
    const searchTerm = getUrlSearchTerm();
    if (searchTerm) {
      const url = buildSearchUrl(
        searchTerm,
        selectedFacet === guidelineTitle ? undefined : guidelineTitle
      );
      navigate(url);
    }
  }

  const saveSearchOnClick = () => {
    const searchTerm = getUrlSearchTerm();
    if (searchTerm) {
      const url = buildSearchUrl(searchTerm, selectedFacet);
      dispatch(saveSearchThunk({ searchTerm: getUrlSearchTerm(), searchUrl: url, remove: savedSearchMatchesCurrentSearch }))
    }
  }

  const clearSavedSearch = (searchKey) => {
    dispatch(saveSearchThunk({ searchTerm: searchKey, remove: true }));
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const guidelineFilter = searchParams.get("guidelinefilter");
    setSelectedFacet(guidelineFilter);
  }, [search]);

  useEffect(() => {
    displaySearch();
  }, []);

  return (
    <div className="col-md-4 columnBlockLayout searchContainer medium">
      <a
        className="slider-arrow hide"
        onClick={(e) => {
          e.preventDefault();
        }}
      >
        <i className="flaticon-double30"></i>
      </a>
      <div className="form-group">
        <div className="tree-menu refine-container" id="sidemenu-container">
          <div id="facet-container" className={classNames("facet-container", style.facetContainer)}>
            <div className={classNames("size-18", style.topicHeader)}>Sort by</div>
            <div className={style.header}>View Results by Guidelines</div>
            <ul className={style.guidelineList}>
              {!loadingStatus && searchResults?.guidelineFacets && orderedGuidelines.map((title) => (
                <GuidelineFacet
                  guideline={title}
                  resultCount={searchResults.guidelineFacets[title]}
                  selected={selectedFacet == title}
                  clickEvent={clickOnGuidelineFacet(title)}
                  key={title}
                />
              ))}
            </ul>

            <div>
              <div className="row">
                <SaveSearchButton saveSearchOnClick={saveSearchOnClick} isBookedMarked={savedSearchMatchesCurrentSearch} />
              </div>
              <SavedSearchResults recentSearches={savedSearchResults} clearSearch={clearSavedSearch} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

SearchResultsSideBar.propTypes = {
  search: PropTypes.string,
};

export default SearchResultsSideBar;